// @ts-nocheck
export default {
  data() {
    return {
      sortings: {
        DateTime: [
          undefined,
          { by: "date-time", icon: "▲", direction: "asc" },
          { by: "date-time", icon: "▼", direction: "desc" },
        ],
        PatientName: [
          undefined,
          { by: "patient-full-name", icon: "▲", direction: "asc" },
          { by: "patient-full-name", icon: "▼", direction: "desc" },
        ],
        Clinic: [
          undefined,
          { by: "clinic-name", icon: "▲", direction: "asc" },
          { by: "clinic-name", icon: "▼", direction: "desc" },
        ],
        LastActivity: [
          undefined,
          { by: "status", icon: "▲", direction: "asc" },
          { by: "status", icon: "▼", direction: "desc" },
        ],
        // New table headers reuse the same underlying sort fields but keep the legacy options intact.
        ProviderName: [
          undefined,
          { by: "clinic-name", icon: "▲", direction: "asc" },
          { by: "clinic-name", icon: "▼", direction: "desc" },
        ],
        ReferralType: [
          undefined,
          { by: "community-name", icon: "▲", direction: "asc" },
          { by: "community-name", icon: "▼", direction: "desc" },
        ],
        Status: [
          undefined,
          { by: "status", icon: "▲", direction: "asc" },
          { by: "status", icon: "▼", direction: "desc" },
        ],
      },
      currentSortKey: "DateTime",
      currentSortIndex: 0,
      listOrder: undefined,
    };
  },

  computed: {
    DateTimeColumnSortingIcon() {
      if (this.currentSortKey === "DateTime") {
        return this.sortings.DateTime[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    PatientNameColumnSortingIcon() {
      if (this.currentSortKey === "PatientName") {
        return this.sortings.PatientName[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    ClinicColumnSortingIcon() {
      if (this.currentSortKey === "Clinic") {
        return this.sortings.Clinic[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    LastActivityColumnSortingIcon() {
      if (this.currentSortKey === "LastActivity") {
        return this.sortings.LastActivity[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    ProviderNameColumnSortingIcon() {
      if (this.currentSortKey === "ProviderName") {
        return this.sortings.ProviderName[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    ReferralTypeColumnSortingIcon() {
      if (this.currentSortKey === "ReferralType") {
        return this.sortings.ReferralType[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
    StatusColumnSortingIcon() {
      if (this.currentSortKey === "Status") {
        return this.sortings.Status[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
  },

  methods: {
    changeListOrder(key, callback) {
      if (this.currentSortKey === key) {
        this.updateCurrentSortingIndex(callback);
        return;
      }

      this.currentSortKey = key;
      this.currentSortIndex = 0;
      this.updateCurrentSortingIndex(callback);
    },
    updateCurrentSortingIndex(callback) {
      if (
        this.currentSortIndex ===
        this.sortings[this.currentSortKey].length - 1
      ) {
        this.currentSortIndex = 0;
        this.listOrder = this.sortings[this.currentSortKey][0];
        callback();
        return;
      }

      this.currentSortIndex++;
      this.listOrder =
        this.sortings[this.currentSortKey][this.currentSortIndex];
      return callback();
    },
  },
};
